module.exports = __webpack_public_path__ + "img/concept2.50aa62f9.png";